import { Title } from '@angular/platform-browser';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import moment from 'moment';
import { DatabaseService } from '@app/database/database.service';
import { MessageAlertService } from '@app/shared/views/_messagesService/_messageAlertServices';
import { AsideService } from '@app/shared/components/aside/aside.service';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { ExamsConfigService } from '../exams-config/exams-config.service';
import { Examen } from '../exams-config/Examen.config';
import { GroupATemplateService } from './group-a-template.service';
import { IEspecialidades } from '../../../../database/models/IEspecialidades.model';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { Trabajador } from '../../../../database/models/IExamen.model';

@Component({
  selector: 'app-group-a-template',
  templateUrl: './group-a-template.component.html',
  styleUrls: ['./group-a-template.component.scss'],
})
export class GroupATemplateComponent implements OnInit, OnDestroy {
  public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
  @Input() examen: any; //IExamen;
  submitted = false;
  public examForm: FormGroup;
  fecha: any;
  seniority = 0;
  unidadTiempo = '';
  radio: any;
  maxDate = new Date();
  maxDateIngreso = new Date();
  minDate: any;
  tiposDictamen: any[] = [];
  especialidades: IEspecialidades[];
  asideObservable: Subscription;
  displayAgentes = false;
  attachedFiles: any = {
    data: [],
    invalid: false,
    isEmpty: true,
    attachedFilesValidQuantity: 0
  };
  configForm: Examen;
  modoVista = false;
  dateWasEdited = false;
  medicoLaboralWasEdited = false;
  medicoNombreWasEdited = true;
  enviandose = false;
  isOnline = true;
  displayModalFirma = false;
  medicoFirmaB64;
  medicoFirmaSigString;

  constructor(
    private titleService: Title,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageAlertServices: MessageAlertService,
    private asideService: AsideService,
    private backgroundSyncService: BackgroundSyncService,
    private databaseService: DatabaseService,
    private examConfigService: ExamsConfigService,
    private templateAService: GroupATemplateService,
    private connectionService: ConnectionService
  ) {
  }

  get f(): any {
    return this.examForm.controls;
  }

  ngOnDestroy(): void {
    if (this.asideObservable) {
      this.asideObservable.unsubscribe();
    }
    this.asideService.setInsideExamen(false);
    this.titleService.setTitle('Provincia ART ML Offline');
  }

  ngOnInit(): void {
    this.titleService.setTitle('Provincia ART ML Offline');

    this.connectionService.monitor().subscribe( ( connected: ConnectionState ) => {
      this.isOnline = connected.hasNetworkConnection;
    })
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    this.cargarFormulario();
    this.getTiposDictamen();
    this.getEspecialidades();
    this.minDate = new Date(moment(this.examen.fechaAsignacion).format());
    this.asideObservable = this.asideService.openModalSubject$.subscribe(
      (data) => {
        this.goBack(data);
      }
    );
    this.asideService.setInsideExamen(true);
  }

  cargarFormulario(): any {
    let codigoTipoExamen = (this.examen.tipoEstudio.codigo !== undefined)
                           ? this.examen.tipoEstudio.tipoEstudioCod
                           : this.examen.tipoEstudio;
    this.configForm = this.examConfigService.getConfig(
      codigoTipoExamen
    );
    this.configForm.id = this.examConfigService.getExamenCodeTypeId(
      codigoTipoExamen
    );
    this.configForm.name = this.examen.provinciaNombreEstudio;
    this.configForm.code = codigoTipoExamen
    if(this.configForm.code === "LAB") {
      this.configForm.isAttachedFileRequire = true;
    }
    this.examForm = this.configForm.examForm;
    this.examen.trabajador.apellidoNombre ? this.examForm.controls.apellidoNombre.setValue(this.examen.trabajador.apellidoNombre) : null;
    this.examen.trabajador.fechaNacimiento ? this.examForm.controls.fechaNacimiento.setValue(new Date(moment(this.examen.trabajador.fechaNacimiento).format())) : null;
    this.calculateAge();
    this.examen.puestoTrabajador ?
    this.examForm.controls.puestoTrabajador.setValue(this.examen.puestoTrabajador) : null;
    this.examen.antiguedadPuestoTrabajador ?
    this.examForm.controls.antiguedadPuestoTrabajador.setValue(this._standarizeDate(this.examen.antiguedadPuestoTrabajador)) : null;
    this.examen.fechaIngresoEmpresa ?
    this.examForm.controls.fechaIngresoEmpresa.setValue(new Date(moment(this.examen.fechaIngresoEmpresa).format())) : null;
    this.restrictDateIngresoEmpresa();
    this.medicoFirmaB64 = this.examen.medicoFirmaB64;
    this.medicoFirmaSigString = this.examen.medicoFirmaSigString;
    this.setValuesOnFormOnVerOrEditMode();
  }

  private calculateAge(): void {
    let edad = null;
    if (this.examForm.controls.fechaNacimiento.value) {
      edad = moment().diff(
        moment(this.examForm.controls.fechaNacimiento.value),
        'years'
      );
    }
    this.examen.trabajador.edad = edad;
  }

  restrictDateIngresoEmpresa(): void {
    if(this.examForm.controls.antiguedadPuestoTrabajador.value != null && this.examForm.controls.antiguedadPuestoTrabajador.value != "") {
      this.maxDateIngreso = this.examForm.controls.antiguedadPuestoTrabajador.value;
    } else {
      this.maxDateIngreso = this.maxDate;
    }
  }

  _standarizeDate(date: any) {
    let splitedDate = date.replace(/\//g, '-');
    const dateParts = splitedDate.split('-');
    if (date.includes('/')) {
      return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) -1, parseInt(dateParts[0]));
    } else {
      return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) -1, parseInt(dateParts[2]));
    }
  }

  capitalize(word: string): string {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  async getTiposDictamen(): Promise<void> {
    const dataFromOffline = await this.databaseService.getAllTiposDictamenFromOfflineDB();
    this.tiposDictamen = dataFromOffline.filter(
      (x) => x.codigo === 'A' || x.codigo === 'I' || x.codigo === 'N'
    );
  }

  // ESPECIALIDADES
  async getEspecialidades(): Promise<void> {
    const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
    this.especialidades = especialidadesListFromOffline;
  }

  calcularAntiguedad(): any {
    if (this.examen.fechaAltaEmpleado) {
      this.seniority = moment().diff(
        moment(this.examen.fechaAltaEmpleado),
        'years'
      );
      if (this.seniority > 1) {
        this.unidadTiempo = 'años';
      } else if (this.seniority < 1) {
        this.seniority = moment().diff(
          moment(this.examen.fechaAltaEmpleado),
          'months'
        );
        if (this.seniority > 1) {
          this.unidadTiempo = 'meses';
        } else {
          this.unidadTiempo = 'mes';
        }
      } else {
        this.unidadTiempo = 'año';
      }
    }
  }

  goBack(ruta?): void {
    if (this.examForm.dirty) {
      this.confirm(ruta);
    } else {
      this.returnToExams(ruta);
    }
  }

  confirm(ruta?): void {
    this.confirmationService.confirm({
      header: `¿Está seguro que desea cancelar la carga del examen?`,
      message: `Si cancela el examen ahora perderá toda la información cargada hasta el momento`,
      key: 'goBackForm',
      accept: () => {
        this.returnToExams(ruta);
      },
    });
  }

  returnToExams(ruta?): void {
    this.router.navigate([ruta ? ruta : 'examenes']);
  }

  /**
   * función que recibe el trigger desde el componente attach-upload-file
   * con el objeto actualizado de la lista de archivos y errores
   * @param  {object} event
   * @example:
   *  {
   *    errors: {
   *      isSizeValid: false
   *      isTypeValid: false,
   *    },
   *    data: [
   *       {
   *        archivoBase64: todounstringpegado,
   *        nombreOriginal: "example.png",
   *        tipo: "png",
   *        size: 121354,
   *        esAlta:false,
   *        esBaja:false
   *    ],
   *    invalid: false,
   *    isEmpty: true,
   *    attachedFilesValidQuantity: 0
   *  }
   */
  getAttachedFiles(event: any): any {
    const { errors } = event;

    this.attachedFiles = event;
    if (errors.isSizeValid && errors.isTypeValid) {
      // asigno la data al objeto para enviar
      return false;
    }
  }

  private navigateInvalidField(classFocus: string): void {
    const invalidFields = [].slice.call(
      document.getElementsByClassName(classFocus)
    ).filter((x) => x.id != 'idFormLogin');
    window.scroll(0, invalidFields[0].offsetTop - 100);
    invalidFields[0].focus();
  }

  formatResponseAndOpenError(error) {
    let message = error.error.message + ' ';
		message = message + error.error.errors.map((x) => {
			return x;
		}).join(' ');
		this.openErrorAlert(message, 'examen');
  }

  private saveToOnline(): void {
    switch (this.configForm.code) {
      // GENERICO
      case 'EST':
        this.templateAService.loadExam(this.buildRequestObservaciones(), this.configForm.baseUrl).subscribe(
          (response) => {
            this.openSuccessAlert(response.message, 'examen');
          }, (error) => {
            this.formatResponseAndOpenError(error);
          }
        );
        break;
      // LABORATORIO
      case 'LAB':
        this.templateAService.loadExam(this.buildRequestObservaciones(), this.configForm.baseUrl).subscribe(
          (response) => {
            this.openSuccessAlert(response.message, 'examen');
          }, (error) => {
            this.formatResponseAndOpenError(error);
          }
        );
        break;
    }
    this.databaseService.deleteItemFromTable(this.examen.id,
      `examenes${ (this.examen.categoriaExamen === 'periodicos'
      ? 'Periodicos'
      : 'Reevaluacion')}`);
    this.databaseService.deleteItemFromTable(this.examen.id,
        `examenes${ (this.examen.categoriaExamen === 'periodicos'
        ? 'PeriodicosFiltrados'
        : 'ReevaluacionFiltrados')}`);
  }

  private saveToOffline(): void {
    let dataToSend;
    switch (this.configForm.code) {
      // GENERICO
      case 'EST':
        dataToSend = this.buildRequestObservaciones();
        break;
      // LABORATORIO
      case 'LAB':
        dataToSend = this.buildRequestObservaciones();
        break;
    }

    const details = (this.examen?.modoVista === "edit") ? 'Los cambios en el examen fueron guardados correctamente' : 'El examen se guardó correctamente en Por enviar';

    dataToSend.fechaCarga = moment().format('yyyy-MM-DD');
    dataToSend.cargadoOffline = true;
    this.examen.modoVista = null;
    this.databaseService
      .setExameneOnExamenesPorEnviarTable(
        this.examen,
        dataToSend,
        false,
        this.examen.categoriaExamen === 'periodicos'
          ? 'Periodicos'
          : 'Reevaluacion',
        this.templateAService.buildUrlApi(this.configForm.baseUrl)
      )
      .then((response) => {
        this.databaseService.deleteItemFromTable(this.examen.id,
          `examenes${ (this.examen.categoriaExamen === 'periodicos'
          ? 'Periodicos'
          : 'Reevaluacion')}`);
        this.databaseService.deleteItemFromTable(this.examen.id,
            `examenes${ (this.examen.categoriaExamen === 'periodicos'
            ? 'PeriodicosFiltrados'
            : 'ReevaluacionFiltrados')}`);
        this.backgroundSyncService.registerEvent('save-examen');
        this.messageAlertServices.setMessage(0, {
          severity: 'success',
          summary: '',
          detail: details,
          key: 'examen',
        });
        setTimeout(() => {
          this.returnToExams();
        }, 500);
      })
      .catch((e) => {
        this.messageAlertServices.setMessage(0, {
          severity: 'error',
          summary: '',
          detail:
            'Ha ocurrido un error. Por favor reinitente más tarde y disculpe las molestias ocasionadas',
          key: 'examen',
        });
      });
  }

  private buildRequestObservaciones(): any {
    const examFormData = this.examForm.value;

    let object = {
      userId: this.currentUser.userId,
      modelId: this.currentUser.modelId,
      username: this.currentUser.username,
      tipoEstudio: this.configForm.code,
      examenNumero: this.examen.id,
      fechaRealizacion: moment(examFormData.fechaRealizacion).format(
        'yyyy-MM-DD'
      ),
      fechaIngresoEmpresa: moment(examFormData.fechaIngresoEmpresa).format(
        'yyyy-MM-DD'
      ),
      puestoTrabajador: examFormData.puestoTrabajador,
      antiguedadPuestoTrabajador: moment(examFormData.antiguedadPuestoTrabajador).format('yyyy-MM-DD'),
      codigoDictamen: examFormData.codigoDictamen,
      medicoNombre: examFormData.medicoNombre,
      medicoMatricula: examFormData.matricula,
      medicoEspecialidad: examFormData.especialidad,
      adjuntos: this.attachedFiles.data,
      esEdicion: !!(this.examen?.modoVista === "edit" && this.isOnline ) || null,
      observaciones: examFormData.observaciones,
      medicoFirmaB64: this.medicoFirmaB64,
      medicoFirmaSigString: this.medicoFirmaSigString,
    };

    object = this.evaluateChangeTrabajador(object);

    return object;
  }

  private evaluateChangeTrabajador(object) {
		if (this.examen.seModificoTrabajador
			|| this.examen.trabajador.fechaNacimiento != moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			|| this.examen.trabajador.apellidoNombre != this.examForm.controls.apellidoNombre.value) {

			object.trabajador = {
				apellidoNombre: this.examForm.controls.apellidoNombre.value,
				fechaNacimiento: moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			};
			this.examen.seModificoTrabajador = true;
		}
		return object;
	}

  private openSuccessAlert(message: string, key: string): void {
    this.submitted = false;
    this.enviandose = false;
    this.messageAlertServices.setMessage(0, {
      severity: 'success',
      summary: '',
      detail: message,
      key: key,
    });
    setTimeout(() => {
      this.returnToExams();
    }, 500);
  }

  private openErrorAlert(message: string, key: string): void {
    this.messageAlertServices.setMessage(0, {
      severity: 'error',
      summary: '',
      detail: message,
      key: key,
    });
    setTimeout(() => {
      const header = document.querySelector('#templateContainer') as any;
      window.scroll(0, header.offsetTop - 150);
    }, 100);
    this.enviandose = false;
  }

  /* /////////////////////////////////////////// */

  togleDatePicker(event): void {
    this.examen.showDatepikerOnEdit = false;
    this.dateWasEdited = true;
    // document.getElementById('date_init').focus();
  }

  /**
   * @description:
   * * Asignacion de valores a los campos en modo edicion
   */
  private setValuesOnFormOnVerOrEditMode(): void {
    if (
      this.examen?.modoVista === "edit"
      || this.examen.modoVista === 'ver'
      || this.examen?.cargadoOffline
    ) {

      /*********************
       * * Campos del Header
       *********************/
      this.examForm.controls.fechaRealizacion.setValue(this.examen.fechaRealizacion);

      /**********************
       *  * Campos del FOOTER
       ***********************/
      this.examForm.controls.codigoDictamen.setValue(this.examen.tipoDictamen !== undefined
                                                     ? this.examen.tipoDictamen
                                                     : this.examen.codigoDictamen);
      this.examen.codigoDictamen = this.examen.tipoDictamen !== undefined
                                   ? this.examen.tipoDictamen
                                   : this.examen.codigoDictamen;
      this.examForm.controls.especialidad.setValue(this.examen.medicoEspecialidad);
      this.examForm.controls.matricula.setValue(this.examen.medicoMatricula);
      this.examForm.controls.medicoNombre.setValue(this.examen.medicoNombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''));

      /*********************
       * * Datos del Examen
       *********************/
      (this.examen?.observaciones) ? this.examForm.controls.observaciones.setValue(this.examen?.observaciones) : null;

    }
  }

  async onSubmit(): Promise<any> {
    this.submitted = true;
    let classToFocus;
    if (this.examForm.invalid || this.attachedFiles.invalid || this.medicoFirmaB64 == null) {
      if (this.attachedFiles.invalid && !this.examForm.invalid) {
        classToFocus = 'app_attachUploadFile__container'
      } else {
        classToFocus = 'ng-invalid'
      }
      this.navigateInvalidField(classToFocus);
      return;
    }
    this.enviandose = true;
    if (this.isOnline) {
      this.saveToOnline();
    } else {
      this.saveToOffline();
    }
  }

  showModalFirma(){
    this.displayModalFirma = true;
  }

  closeModalFirma(){
    this.displayModalFirma = false;
  }

  recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
    this.medicoFirmaB64 = datos.firmaB64;
    this.medicoFirmaSigString = datos.firmaSigString;
  }

  deshabilitarApellidoNombreTrabajador() {
    return this.examen.trabajador.apellidoNombre.replace(/[^a-zA-Z]/g, '').toLowerCase() !== 'alta' && this.examen.trabajador.apellidoNombre.trim().length !== 0;
  }
}
